// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA498LEAjTo3Nl2EztGwXmEvnmjWn0DcJM",
  authDomain: "idea-box-81cb3.firebaseapp.com",
  projectId: "idea-box-81cb3",
  storageBucket: "idea-box-81cb3.appspot.com",
  messagingSenderId: "1045773553323",
  appId: "1:1045773553323:web:9f09d521caa86ede1c71ee",
  measurementId: "G-HVQM31SFQG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
const analytics = getAnalytics(app);